import React from 'react';

const Search = (props) => {


  return (
    <div className="Search">
      <div className="con">
        <form className="wrap-search" onSubmit={props.onClick}>
          <div className="wrap-dorpdown">
            <select name="filter" onChange={props.handleSelectChange}>
              <option value="title">제목</option>
              <option value="text">내용</option>
            </select>
            
          </div>
          <input type="search" placeholder="내용 입력" value = {props.search} onChange={props.onChange}/>
          <input type="submit" value="검색"/>
        </form>
      </div>
    </div>
  );
}

export default Search;